import * as React from 'react';

import { InterestsSetType } from './interestsEditor';
import { RetargetingConditionData } from './retargeting';

export enum AudienceTargetingsType {
    audience = 'audience',
    interests = 'interests',
    behaviors = 'behaviors',
    family = 'family',
    goal = 'goal',
    socialDemo = 'socialDemo',
    audienceMetrics = 'audienceMetrics',
    audioGenres = 'audioGenres'
}

export interface AudienceTargetingsValue {
    [AudienceTargetingsType.interests]?: InterestsSetType[];
    [AudienceTargetingsType.socialDemo]?: string[];
    [AudienceTargetingsType.audience]?: string[];
    [AudienceTargetingsType.family]?: string[];
    [AudienceTargetingsType.behaviors]?: string[];
    [AudienceTargetingsType.audienceMetrics]?: RetargetingConditionData;
    [AudienceTargetingsType.audioGenres]?: string[];
}

export interface AudienceTargetingsEditorState {
    isOpen: boolean;
    templateName: string;
}

export interface AudienceTargetingsEditorDescription {
    title: React.ReactNode;
    titleName: string;
    description: string;
    noValueDescription: string;
}

export interface InterestsTargetingEditorState {
    isOpen: boolean;
    value: InterestsSetType[];
}

export interface CryptaSocialDemoEditorState {
    isOpen: boolean;
    checkedItems: string[];
}

export interface CryptaGroupFamilyEditorState {
    isOpen: boolean;
    checkedItems: string[];
}

export interface CryptaBehavioralEditorState {
    isOpen: boolean;
    checkedItems: string[];
}

export interface CryptaAudioGenresEditorState {
    isOpen: boolean;
    checkedItems: string[];
}
